export function classWatched(classId) {
  if (process.env.NODE_ENV === 'development') {
    return {
      success: true,
      class_id: '1492758',
      flag: true,
    };
  }

  const formData = new FormData();
  formData.append('class_id', classId);

  const wpnonce = window?.dataWP?.config?.wpnonce;

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : '';

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/class_watched_flag${wpNonceParam}`,
    {
      method: 'POST',
      body: formData,
    }
  ).then((res) => {
    // window.analytics.track('class:mark_watched', {
    //   action: "class_watch_flag",
    //   class_id: classId
    // });

    return res.json();
  });
  // .catch((e) => {
  //   window.analytics.track('class:mark_unwatched', {
  //     action: "class_watch_flag",
  //     class_id: classId
  //   });
  // });
}
